var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3703 10.1704L18.7103 8.75041C20.1303 7.25041 20.7703 5.54042 18.5603 3.45042C16.3503 1.37042 14.6803 2.10041 13.2603 3.60041L5.05034 12.2904C4.74034 12.6204 4.44034 13.2704 4.38034 13.7204L4.01034 16.9604C3.88034 18.1304 4.72034 18.9304 5.88034 18.7304L9.10034 18.1804C9.55034 18.1004 10.1803 17.7704 10.4903 17.4304L14.4403 13.2504",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8896 5.0498C12.3196 7.8098 14.5596 9.9198 17.3396 10.1998",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22H14",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H21",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconNew);
export default __webpack_public_path__ + "static/media/editIconNew.62cff02ec9a0af460d22050ed9660d7f.svg";
export { ForwardRef as ReactComponent };